export default {
  query: '/auth/res/syncLog', // 获取日志数据
};



// WEBPACK FOOTER //
// ./src/api/resourceDevSyncLog.js